<template>
  <v-app id="inspire">
    <!--<v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
              cols="6"
              class="text-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>-->

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <!--<v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->
      <v-toolbar-title
				v-if="esCaja"
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Caja</span>
				<v-btn icon @click="cajaActiva = true"><v-icon>mdi-cash</v-icon></v-btn>
				<v-btn icon @click="cajaActiva = false"><v-icon>mdi-chef-hat</v-icon></v-btn>
      </v-toolbar-title>
      <v-toolbar-title
				v-else
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Cocina</span>
      </v-toolbar-title>
      <!--<v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      />-->
      <!--<v-spacer />
      <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn
        icon
        large
      >
        <v-avatar
          size="32px"
          item
        >
          <v-img
            src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
            alt="Vuetify"
          /></v-avatar>
      </v-btn>-->
			<v-spacer></v-spacer>
			<v-menu offset-y left>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item @click="$root.cerrarSesión()">
						<v-list-item-title>Cerrar sesión</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
    </v-app-bar>
    <v-content>
			<!-- Empieza temporal para caja -->
			<v-container
				v-if="esCaja && cajaActiva"
        class="fill-height"
        fluid
      >
				<div
					v-for="u in pedidosAgrupadosPorUbicación"
					:key="u.id"
					style="width: 100%"
				>
					<!-- id: u {{u.id}} -->
					<div
						v-for="p in u.pedidos"
						:key="p.id"
						style="display: inline-block; margin: 10px"
						v-if="p.estado === 'SERVIDO'"
					>
						<v-card style="max-width: 400px">
							<pedido-item :pedido="p"></pedido-item>
							<v-divider></v-divider>
							<div class="ma-2 text-center">
								{{ mayúsculaInicial(p.ubicación.tipo) }} {{ p.ubicación.identificación }}
							</div>
							<v-divider></v-divider>
								<div v-if="p.opción && p.opción.precios && p.opción.precios.length" class="pa-3">
									<h4 class="text-center"><strong>$ {{ Intl.NumberFormat('es').format(p.opción.precios[0].precio) }}</strong></h4>
								</div>
							<v-divider></v-divider>
							<opcion-resumen :opción="p.opción"></opcion-resumen>
							<v-card-actions>
								<v-btn
									small
									tile
									block
									class="mb-2"
									color="primary"
									@click="confirmarPagar = !confirmarPagar"
									:loading="confirmandoPago"
									v-if="p.estado === 'SERVIDO'"
								>
									Recibir pago
								</v-btn>
							</v-card-actions>
							<v-card-actions>
								<v-btn
									v-if="p.opción && p.opción.precios && p.opción.precios.length"
									@click="abrirVerImpresión(p)"
									block
								>
									Imprimir
								</v-btn>
							</v-card-actions>
							<v-card-text>
								<v-alert tile dense type="info" border="left" v-if="p.estado === 'SERVIDO' && confirmarPagar">
									<v-select
										v-model="métodoDePago"
										:items="métodosDePago"
										label="Método de pago"
										dense
									></v-select>
									<p class="mb-0">¿Confirma que este pedido ha sido pagado? </p>
									<v-btn x-small tile color="blue-grey" class="white--text" @click="pagarPedido(p.id)" :loading="confirmandoPago" :disabled="!métodoDePago">
										Sí, marcar como Pagado
									</v-btn>
								</v-alert>
							</v-card-text>
						</v-card>
					</div>
				</div>
			</v-container>
			<!-- Termina temporal para caja -->
      <v-container
				v-else
        class="fill-height"
        fluid
      >
				<!-- - ubicacion, - tiempo, - opcion -->
				<!--
				<ul>
					<li v-for="p in pedidos" :key="p.id">{{ p.opción.nombre }}</li>
				</ul>
				<ul>
					<li v-for="(o, i) in pedidosAgrupadosPorOpción" :key="i">
						{{ o.nombre }}
						<ol v-for="p in o.pedidos" :key="p.id">{{ p.id }}</ol>
					</li>
				</ul>
				<ul>
					<li v-for="u in pedidosAgrupadosPorUbicación" :key="u.id">
						{{ u.tipo }} {{ u.identificación }}
						<ol v-for="p in u.pedidos" :key="p.id">{{ p.id }}</ol>
					</li>
				</ul>

				iiiiiiiiiiiiiiiiiiiiiiiii
				-->

				<div
					v-for="p in pedidos"
					:key="p.id"
					style="margin: 10px"
					v-if="p.estado === 'ORDENADO' || p.estado === 'PREPARANDO' || p.estado === 'EN_CAMINO'"
				>
					<v-card style="max-width: 400px">
						<pedido-item :pedido="p"></pedido-item>
						<v-divider></v-divider>
						<div class="ma-2 text-center">
							{{ mayúsculaInicial(p.ubicación.tipo) }} {{ p.ubicación.identificación }}
						</div>
						<v-divider></v-divider>
						<opcion-resumen :opción="p.opción"></opcion-resumen>
						<v-card-actions>
							<v-btn
								small
								tile
								block
								class="mb-2"
								color="primary"
								@click="confirmarPrepararPedido = !confirmarPrepararPedido"
								:loading="preparandoPedido"
								v-if="p.estado === 'ORDENADO'"
							>
								Preparar pedido
							</v-btn>
							<v-btn
								small
								tile
								block
								class="mb-2"
								color="primary"
								@click="confirmarPedidoEnCamino = !confirmarPedidoEnCamino"
								:loading="entregandoPedido"
								v-if="p.estado === 'PREPARANDO'"
							>
								Pedido listo
							</v-btn>

							<!--<v-btn
								text
								color="primary"
							>More</v-btn>
							<v-spacer />
							<v-btn
								text
								color="primary"
								@click="dialog = false"
							>Cancel</v-btn>
							<v-btn
								text
								@click="dialog = false"
							>Save</v-btn>-->
						</v-card-actions>
						<v-card-text>
							<v-alert tile dense type="info" border="left" v-if="p.estado === 'ORDENADO' && confirmarPrepararPedido">
								<p class="mb-0">¿Confirma que este pedido va a ser preparado? </p>
								<v-btn x-small tile color="blue-grey" class="white--text" @click="prepararPedido(p.id)" :loading="preparandoPedido">
									Sí, marcar como En preparación
								</v-btn>
							</v-alert>
							<v-alert tile dense type="info" border="left" v-if="p.estado === 'PREPARANDO' && confirmarPedidoEnCamino">
								<p class="mb-0">¿Confirma que este pedido va en camino a ser servido? </p>
								<v-btn x-small tile color="blue-grey" class="white--text" @click="entregarPedido(p.id)" :loading="entregandoPedido">
									Sí, marcar como En camino
								</v-btn>
							</v-alert>
						</v-card-text>
					</v-card>
				</div>

        <!--<v-row
          align="center"
          justify="center"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                :href="source"
                icon
                large
                target="_blank"
                v-on="on"
              >
                <v-icon large>mdi-code-tags</v-icon>
              </v-btn>
            </template>
            <span>Source</span>
          </v-tooltip>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                large
                href="https://codepen.io/johnjleider/pen/MNYLdL"
                target="_blank"
                v-on="on"
              >
                <v-icon large>mdi-codepen</v-icon>
              </v-btn>
            </template>
            <span>Codepen</span>
          </v-tooltip>
        </v-row>-->
      </v-container>
    </v-content>
    <!--<v-btn
      bottom
      color="pink"
      dark
      fab
      fixed
      right
      @click="dialog = !dialog"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>-->
    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title class="grey darken-2">
          Create contact
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="12"
            >
              <v-row
                align="center"
                class="mr-0"
              >
                <v-avatar
                  size="40px"
                  class="mx-3"
                >
                  <img
                    src="//ssl.gstatic.com/s2/oz/images/sge/grey_silhouette.png"
                    alt=""
                  >
                </v-avatar>
                <v-text-field
                  placeholder="Name"
                />
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-text-field
                prepend-icon="business"
                placeholder="Company"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                placeholder="Job title"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                prepend-icon="mail"
                placeholder="Email"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                type="tel"
                prepend-icon="phone"
                placeholder="(000) 000 - 0000"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                prepend-icon="notes"
                placeholder="Notes"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
          >More</v-btn>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >Cancel</v-btn>
          <v-btn
            text
            @click="dialog = false"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

		<v-dialog
			v-model="verImpresion"
      width="400px"
		>
			<v-card>
				<v-card-text>
					<FacturaImpresion
						:precio="impresionDatos.precio"
						:descripción="impresionDatos.descripción"
						ref="impfac"
					></FacturaImpresion>
				</v-card-text>
				<v-card-actions>
					<v-btn block @click="imprimir">
						Imprimir
					</v-btn>
				</v-card-actions>
				<v-card-actions>
					<v-btn block @click="imprimir2">
						Imprimir
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
  </v-app>
</template>

<script>
	import { mayúsculaInicial } from '../../../cliente-comun/utilidades'
	import OpcionResumen from '@/../../cliente-comun/componentes/pedidos/Opcion_Resumen'; // pendiente --------- este componente está duplciado en servicio ---
	import PedidoItem from '@/../../cliente-comun/componentes/pedidos/Pedido_Item';
	import FacturaImpresion from '@/components/FacturaImpresion'

  export default {
    props: {
      source: String,
    },
		components: {
			OpcionResumen,
			PedidoItem,
			FacturaImpresion
		},
    data: () => ({
			esCaja: false, // Forzado temporal para desplegar para Caja ---------------------- poner en false si es para Cocina ------ IMPORTANTE ---
			cajaActiva: true,
			//
      dialog: false,
      drawer: null,
      items: [
        { icon: 'mdi-contacts', text: 'Contacts' },
        { icon: 'mdi-history', text: 'Frequently contacted' },
        { icon: 'mdi-content-copy', text: 'Duplicates' },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'Labels',
          model: true,
          children: [
            { icon: 'mdi-plus', text: 'Create label' },
          ],
        },
        {
          icon: 'mdi-chevron-up',
          'icon-alt': 'mdi-chevron-down',
          text: 'More',
          model: false,
          children: [
            { text: 'Import' },
            { text: 'Export' },
            { text: 'Print' },
            { text: 'Undo changes' },
            { text: 'Other contacts' },
          ],
        },
        { icon: 'mdi-settings', text: 'Settings' },
        { icon: 'mdi-message', text: 'Send feedback' },
        { icon: 'mdi-help-circle', text: 'Help' },
        { icon: 'mdi-cellphone-link', text: 'App downloads' },
        { icon: 'mdi-keyboard', text: 'Go to the old version' },
			],
			//
			//
			tiempoPermanenciaTerminados: 10 * 60 * 1000,
			//
			//Pedidos:
			pedidos: [],
			pedidosAgrupadosPorOpción: [],
			pedidosAgrupadosPorUbicación: [],
			//
			confirmarPrepararPedido: false,
			preparandoPedido: false,
			//
			confirmarPedidoEnCamino: false,
			entregandoPedido: false,
			//
			confirmarPagar: false,
			confirmandoPago: false,
			//
			métodoDePago: '',
			métodosDePago: ['Efectivo', 'Nequi'],
			//
			verImpresion: false,
			impresionDatos: {
				precio: '',
				descripción: ''
			}
		}),
		created: function() {
			//this.inicializarSecciones()
			//this.inicializarPedidos()
			//this.inicializarOpcionesDeMenú()
			//this.inicializarUbicaciones()
			//this.inicializarCategorías()
			this.inicializarPedidos()
		},
		methods: {
			imprimir: function() {
				console.log('iiiiiiiiii', this.$refs)
				this.$refs.impfac.imprimir()
			},
			imprimir2: function() {
				this.$refs.impfac.imprimir2()
			},
			abrirVerImpresión: function(p) {
				if (!p.opción || !p.opción.precios || !p.opción.precios.length) {
					//
				}

				this.impresionDatos.precio = p.opción.precios[0].precio
				this.impresionDatos.descripción = p.opción.nombre
				this.verImpresion = true
			},
			mayúsculaInicial: function(t) {
				return mayúsculaInicial(t)
			},
			pagarPedido: function(identificador) {
				this.confirmandoPago = true
				this.$root.axios.patch(`/pedidos/${identificador}`, {estado: 'PAGADO', pago: {método: this.métodoDePago}}).then(rta => {
					this.confirmarPagar = false
					this.confirmandoPago = false
				}).catch(err => {
					this.confirmandoPago = false
					alert(err.error || 'Ocurrió un error al pagar el pedido. Intente de nuevo.')
				})
			},
			// Por aquí voy --------------- continuar con formato de impresión ----------- y agregar listado de los ya pagados --- y agregar anular ----------
			prepararPedido: function(identificador) {
				this.preparandoPedido = true
				this.$root.axios.patch(`/pedidos/${identificador}`, {estado: 'PREPARANDO'}).then(rta => {
					this.confirmarPrepararPedido = false
					this.preparandoPedido = false
				}).catch(err => {
					this.preparandoPedido = false
					alert(err.error || 'Ocurrió un error al preparar el pedido. Intente de nuevo.')
				})
			},
			entregarPedido: function(identificador) {
				this.entregandoPedido = true
				this.$root.axios.patch(`/pedidos/${identificador}`, {estado: 'EN_CAMINO'}).then(rta => {
					this.confirmarPedidoEnCamino = false
					this.entregandoPedido = false
				}).catch(err => {
					this.entregandoPedido = false
					alert(err.error || 'Ocurrió un error al entregar el pedido. Intente de nuevo.')
				})
			},
			actualizarListadoDePedidos_Agregar: function (P) {
				this.pedidos.push(P)

				console.log('PPPPPPPPPPPP', P)

				// Agrupados por opción:
				let iPO = this.pedidosAgrupadosPorOpción.findIndex(o => o.nombre === P.opción.nombre)
				if (iPO >= 0) {
					this.pedidosAgrupadosPorOpción[iPO].pedidos.push(P)
				} else {
					let opc = {
						nombre: P.opción.nombre,
						descripción: P.opción.descripción,
						pedidos: [P]
					}
					this.pedidosAgrupadosPorOpción.push(opc)
				}

				// Agrupados por ubicación:
				let iPU = this.pedidosAgrupadosPorUbicación.findIndex(u => u.id === P.ubicación.id)
				if (iPU >= 0) {
					this.pedidosAgrupadosPorUbicación[iPU].pedidos.push(P)
				} else {
					let ubi = {
						id: P.ubicación.id,
						identificación: P.ubicación.identificación,
						tipo: P.ubicación.tipo,
						pedidos: [P]
					}
					this.pedidosAgrupadosPorUbicación.push(ubi)
				}
			},
			actualizarListadoDePedidos_Cambiar: function (P) {
				/*let i = this.pedidos.findIndex(p => p.id === P.id)
				if (i >= 0) {
					this.$set(this.pedidos, i, P)
				} else {
					console.warn('Error [46392]') // Esto no debería ocurrir nunca...
				}

				// Agrupados por opción:
				let iPO = this.pedidosAgrupadosPorOpción.findIndex(o => o.nombre === P.opción.nombre)
				if (iPO >= 0) {
					let iP = this.pedidosAgrupadosPorOpción[iPO].pedidos.findIndex(p => p.id === P.id)
					if (iP >= 0) {
						this.$set(this.pedidosAgrupadosPorOpción[iPO].pedidos, iP, P)
					} else {
						console.warn('Error [46393b]') // Esto no debería ocurrir nunca...
					}
				} else {
					console.warn('Error [46393a]') // Esto no debería ocurrir nunca...
				}

				// Agrupados por ubicación:
				let iPU = this.pedidosAgrupadosPorUbicación.findIndex(u => u.id === P.ubicación.id)
				if (iPU >= 0) {
					let iP = this.pedidosAgrupadosPorUbicación[iPU].pedidos.findIndex(p => p.id === P.id)
					if (iP >= 0) {
						this.$set(this.pedidosAgrupadosPorUbicación[iPU].pedidos, iP, P)
					} else {
						console.warn('Error [46394b]') // Esto no debería ocurrir nunca...
					}
				} else {
					console.warn('Error [46394a]') // Esto no debería ocurrir nunca...
				}*/

				let idcs = this.obtenerÍndicesDePedido(P)

				if (idcs.iP >= 0) {
					//this.pedidos.splice(idcs.iP, 1)
					this.$set(this.pedidos, idcs.iP, P)
				}

				if (idcs.iPAPO >= 0 && idcs.iPAPO_iP >= 0) {
					this.$set(this.pedidosAgrupadosPorOpción[idcs.iPAPO].pedidos, idcs.iPAPO_iP, P)
				}

				if (idcs.iPAPU >= 0 && idcs.iPAPU_iP >= 0) {
					this.$set(this.pedidosAgrupadosPorUbicación[idcs.iPAPU].pedidos, idcs.iPAPU_iP, P)
				}
			},
			actualizarListadoDePedidos_Quitar: function (P) {
				/*let ind = this.pedidos.findIndex(p => p.id === P.id)
				if (ind >= 0) {
					this.pedidos.splice(ind, 1)
				} else {
					console.warn('Error [46381]') // Esto no debería ocurrir nunca...
				}

				// Agrupados por opción:
				let iPO = this.pedidosAgrupadosPorOpción.findIndex(o => o.nombre === P.opción.nombre)
				if (iPO >= 0) {
					let iP = this.pedidosAgrupadosPorOpción[iPO].pedidos.findIndex(p => p.id === P.id)
					if (iP >= 0) {
						this.pedidosAgrupadosPorOpción[iPO].pedidos.splice(iP, 1)
					} else {
						console.warn('Error [46382b]') // Esto no debería ocurrir nunca...
					}
				} else {
					console.warn('Error [46382a]') // Esto no debería ocurrir nunca...
				}

				// Agrupados por ubicación:
				let iPU = this.pedidosAgrupadosPorUbicación.findIndex(u => u.id === P.ubicación.id)
				if (iPU >= 0) {
					let iP = this.pedidosAgrupadosPorUbicación[iPU].pedidos.findIndex(p => p.id === P.id)
					if (iP >= 0) {
						this.pedidosAgrupadosPorUbicación[iPU].pedidos.splice(iP, 1)
					} else {
						console.warn('Error [46383b]') // Esto no debería ocurrir nunca...
					}
				} else {
					console.warn('Error [46383a]') // Esto no debería ocurrir nunca...
				}*/

				let idcs = this.obtenerÍndicesDePedido(P)

				if (idcs.iP >= 0) {
					this.pedidos.splice(idcs.iP, 1)
				}

				if (idcs.iPAPO >= 0 && idcs.iPAPO_iP >= 0) {
					this.pedidosAgrupadosPorOpción[idcs.iPAPO].pedidos.splice(idcs.iPAPO_iP, 1)
				}

				if (idcs.iPAPU >= 0 && idcs.iPAPU_iP >= 0) {
					this.pedidosAgrupadosPorUbicación[idcs.iPAPU].pedidos.splice(idcs.iPAPU_iP, 1)
				}
			},
			actualizarListadoDePedidos: function (P, C) {
				//
				/*
				if (obj.estado === 'PAGADO' || obj.estado === 'CANCELADO' || obj.estado === 'ANULADO') {
							setTimeout( () => {
								this.eliminarPedidoDeUbicación(obj)
							}, 10000)
						}
				*/
				console.log('actualizarListadoDePedidos... ', C.type, P)
				if (C.type === "added") {
					if (P.estado !== 'ORDENADO' && P.estado !== 'PREPARANDO' && P.estado !== 'EN_CAMINO' && P.estado !== 'SERVIDO') {
						return
					}

					this.actualizarListadoDePedidos_Agregar(P)
					return
				}

				if (C.type === "modified") {
					if (P.estado !== 'ORDENADO' && P.estado !== 'PREPARANDO' && P.estado !== 'EN_CAMINO' && P.estado !== 'SERVIDO') {
						this.actualizarListadoDePedidos_Quitar(P)
						return
					}

					this.actualizarListadoDePedidos_Cambiar(P)
					return
				}

				if (C.type === "removed") {
					this.actualizarListadoDePedidos_Quitar(P)
					return
				}

				console.warn('Error [64738]') // Esto no debería ocurrir nunca...
			},
			obtenerÍndicesDePedido: function (P) {
				let idcs = {
					'iP': -1,
					'iPAPO': -1,
					'iPAPO_iP': -1,
					'iPAPU': -1,
					'iPAPU_iP': -1,
				}

				idcs.iP = this.pedidos.findIndex(p => p.id === P.id)

				idcs.iPAPO = this.pedidosAgrupadosPorOpción.findIndex(o => o.nombre === P.opción.nombre)
				if (idcs.iPAPO >= 0) {
					idcs.iPAPO_iP = this.pedidosAgrupadosPorOpción[idcs.iPAPO].pedidos.findIndex(p => p.id === P.id)
				}

				idcs.iPAPU = this.pedidosAgrupadosPorUbicación.findIndex(u => u.id === P.ubicación.id)
				if (idcs.iPAPU >= 0) {
					idcs.iPAPU_iP = this.pedidosAgrupadosPorUbicación[idcs.iPAPU].pedidos.findIndex(p => p.id === P.id)
				}

				if (idcs.iP < 0 || idcs.iPAPO < 0 || idcs.iPAPO_iP < 0 || idcs.iPAPU < 0 || idcs.iPAPU_iP < 0) {
					console.error('índices de pedido no localizados: ', idcs) // Esto no debería ocurrir nunca...
				}

				return idcs
			},
			inicializarPedidos: function() {
				let haceCincoHoras
				if (this.$root.modo === 'DESARROLLO') {
					haceCincoHoras = new Date((new Date()).getTime() - (600*60*60*1000))
				} else {
					haceCincoHoras = new Date((new Date()).getTime() - (5*60*60*1000))
				}
				this.$root.firestore.collection("restaurantes").doc(this.$root.datos.id).collection("pedidos").where('fecha_de_creación', '>=', haceCincoHoras).orderBy('fecha_de_creación').onSnapshot( snapshot => {
					snapshot.docChanges().forEach( change => {
						let obj = Object.assign({'id': change.doc.id}, change.doc.data())
						this.actualizarListadoDePedidos(obj, change)
						console.log('this.pedidos', this.pedidos.length)
						console.log('this.pedidosAgrupadosPorOpción', this.pedidosAgrupadosPorOpción.length)
						console.log('this.pedidosAgrupadosPorUbicación', this.pedidosAgrupadosPorUbicación.length)
					});
				});
			},
		}
  }
</script>